import React from 'react'
import Content from './Content'
import DataTypeSwitch from './DataTypeSwitch'
import ChartModal from './ChartModal'
import 'styles/app/apps/slaMonitor/environment.scss'

function Environment() {
  return (
    <div className="environment-container">
      <Content />
      <DataTypeSwitch />
      <ChartModal />
    </div>
  )
}

export default Environment
